export default class NotOkError extends Error {
  constructor(response, data) {
    super("Unexpected response from API");
    this.name = 'NotOkError';
    this.response = response;
    this.data = data;
  }
}
